// ════════════════════════════════════════════════════════════
//  online/net.js — the only file in online/ that talks to Firebase
// ════════════════════════════════════════════════════════════
//  lockstep.js, rooms.js and stage.js take a `net` and never import
//  firebase themselves, so tools/net-check.mjs can run them in Node on
//  a fake, laggy network and prove two screens see one fight.
// ════════════════════════════════════════════════════════════
import { ref, push, onChildAdded, onValue, runTransaction, set, update, get, remove, onDisconnect, serverTimestamp } from "firebase/database";
import { db } from "../firebase";
import { clockKnown } from "./ie.js";

export const fbNet = {
  push: (p, v) => push(ref(db, p), v),
  set: (p, v) => set(ref(db, p), v),
  update: (p, v) => update(ref(db, p), v),
  remove: (p) => remove(ref(db, p)),
  get: async (p) => { const s = await get(ref(db, p)); return s.exists() ? s.val() : null; },
  // fn(cur) → next (or undefined to abort). Resolves { committed, value }.
  txn: async (p, fn) => { const r = await runTransaction(ref(db, p), fn); return { committed: r.committed, value: r.snapshot.val() }; },
  onChild: (p, cb) => onChildAdded(ref(db, p), (s) => cb(s.val(), s.key), () => {}),
  onValue: (p, cb) => onValue(ref(db, p), (s) => cb(s.exists() ? s.val() : null), () => {}),
  onDisconnectRemove: (p) => onDisconnect(ref(db, p)).remove(),
  // the server writes its own clock here (a bet's time can't be faked by a device clock)
  TS: () => serverTimestamp(),
  // has the server's clock offset arrived? (stage.js won't write a seed on a guessed clock)
  clockKnown,
};
